import { initializeApp } from 'firebase/app';

// Import the functions you need from the SDKs you need
const preprodFirebaseConfig = {
  apiKey: 'AIzaSyAEADMwaGaIR3SPEbjXa5a9_3IKBO_stqQ',
  authDomain: 'nrk-pin-flippklipp-preprod.firebaseapp.com',
  projectId: 'nrk-pin-flippklipp-preprod',
  storageBucket: 'nrk-pin-flippklipp-preprod.firebasestorage.app',
  messagingSenderId: '338888225174',
  appId: '1:338888225174:web:6111af2d115ff45492adb7',
};

const prodFirebaseConfig = {
  apiKey: 'AIzaSyDYN31gyOnesNsflw4A3hVKjm83XXwJpZE',
  authDomain: 'nrk-pin-flippklipp-prod.firebaseapp.com',
  projectId: 'nrk-pin-flippklipp-prod',
  storageBucket: 'nrk-pin-flippklipp-prod.firebasestorage.app',
  messagingSenderId: '240832588679',
  appId: '1:240832588679:web:c57ca7444b8a2fae8d8122',
};

const firebaseConfig =
  import.meta.env.VITE_APP_ENV === 'prod'
    ? prodFirebaseConfig
    : preprodFirebaseConfig;

export const app = initializeApp(firebaseConfig);
